import { APP_LOGIN_URL } from '@/config'

export function Hero() {
  return (
    <section className="relative pt-28 pb-20 bg-hero overflow-hidden">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-surface-900 leading-tight">
              Ditch the paper.{' '}
              <span style={{ color: '#08C6EA' }}>Run your business</span>{' '}
              <span className="text-surface-900">with confidence.</span>
            </h1>

            <p className="mt-6 text-lg text-surface-600 max-w-xl mx-auto lg:mx-0">
              Ledger replaces your paper ledger with a simple app that tracks income, expenses, and customer credit — no accounting knowledge needed. Works on any phone or computer.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4">
              <a href={APP_LOGIN_URL} className="w-full sm:w-auto btn btn-primary text-base px-8 py-3.5">
                Start for Free
              </a>
              <a href="/features" className="w-full sm:w-auto btn btn-secondary text-base px-8 py-3.5">
                See How It Works
              </a>
            </div>

            <p className="mt-4 text-sm text-surface-500">
              Free to start · No credit card required
            </p>
          </div>

          {/* Right: Hero Illustration */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-brand-50 via-cyan-50 to-surface-100 rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-[4/3] flex items-center justify-center p-8">
                <div className="relative w-full h-full">

                  {/* Daily sales card */}
                  <div className="absolute top-4 left-8 bg-white rounded-lg shadow-lg p-3 transform -rotate-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 bg-emerald-100 rounded flex items-center justify-center">
                        <span className="text-emerald-600 text-xs font-bold">Rs</span>
                      </div>
                      <div className="text-xs">
                        <div className="font-semibold text-surface-900">Today's Sales</div>
                        <div className="text-emerald-600">Rs 24,500</div>
                      </div>
                    </div>
                  </div>

                  {/* Credit tracking card */}
                  <div className="absolute top-4 right-8 bg-white rounded-lg shadow-lg p-3 transform rotate-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded flex items-center justify-center" style={{ backgroundColor: '#e0f9fd' }}>
                        <span className="text-xs font-bold" style={{ color: '#08C6EA' }}>CR</span>
                      </div>
                      <div className="text-xs">
                        <div className="font-semibold text-surface-900">Credit Given</div>
                        <div className="text-surface-500">Amal · Rs 1,200</div>
                      </div>
                    </div>
                  </div>

                  {/* Cash flow card */}
                  <div className="absolute bottom-12 right-12 bg-white rounded-lg shadow-lg p-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                        <span className="text-emerald-600 text-lg font-bold">Rs</span>
                      </div>
                      <div className="text-xs">
                        <div className="font-semibold text-surface-900">This Month</div>
                        <div className="text-emerald-600">+Rs 184,000</div>
                      </div>
                    </div>
                  </div>

                  {/* Central accounting icon */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="w-20 h-20 rounded-xl flex items-center justify-center shadow-xl" style={{ backgroundColor: '#08C6EA' }}>
                      <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" />
                      </svg>
                    </div>
                  </div>

                  {/* Decorative connecting lines */}
                  <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300">
                    <path d="M80 60 Q200 100 200 150" stroke="#08c6ea" strokeWidth="2" fill="none" strokeDasharray="4 4" />
                    <path d="M320 60 Q200 100 200 150" stroke="#08c6ea" strokeWidth="2" fill="none" strokeDasharray="4 4" />
                    <path d="M300 240 Q200 200 200 150" stroke="#10b981" strokeWidth="2" fill="none" strokeDasharray="4 4" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
